const ColorMap = {
  blue: {
    border: '1px solid #DBD8FF',
    backgroundColor: '#E9E8FB',
    color: '#6C60FF',
  },
  red: {
    border: '1px solid #EDBCBC',
    backgroundColor: '#FCE7E7',
    color: '#E10808',
  },
  grey: {
    border: '1px solid #CCC',
    backgroundColor: '#EEEEEE',
    color: '#333',
  },
};

const ALARM_TYPE = {
  PRODUCT_COMPLETE_MOD_INFO_1: {
    colorInfo: ColorMap.blue,
    buttonText: '상품 승인 완료',
    bodyText: '정보수정 1차 승인완료 되었습니다.',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_COMPLETE_MOD_INFO_2: {
    colorInfo: ColorMap.blue,
    buttonText: '상품 승인 완료',
    bodyText: '정보수정 2차 승인완료 되었습니다.',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_COMPLETE_ADJ_PRICE_1: {
    colorInfo: ColorMap.blue,
    buttonText: '상품 승인 완료',
    bodyText: '단가조정 1차 승인완료 되었습니다.',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_COMPLETE_ADJ_PRICE_2: {
    colorInfo: ColorMap.blue,
    buttonText: '상품 승인 완료',
    bodyText: '단가조정 2차 승인완료 되었습니다.',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_COMPLETE_NEW_REG_1: {
    colorInfo: ColorMap.blue,
    buttonText: '상품 승인 완료',
    bodyText: '신규등록 1차 승인완료 되었습니다.',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_COMPLETE_NEW_REG_2: {
    colorInfo: ColorMap.blue,
    buttonText: '상품 승인 완료',
    bodyText: '신규등록 2차 승인완료 되었습니다.',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_REJECT_MOD_INFO_1: {
    colorInfo: ColorMap.red,
    buttonText: '상품 반려',
    bodyText: '정보수정 1차 승인반려 되었습니다.\n반려사유를 확인하세요',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_REJECT_MOD_INFO_2: {
    colorInfo: ColorMap.red,
    buttonText: '상품 반려',
    bodyText: '정보수정 2차 승인반려 되었습니다.\n반려사유를 확인하세요',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_REJECT_ADJ_PRICE_1: {
    colorInfo: ColorMap.red,
    buttonText: '상품 반려',
    bodyText: '단가조정 1차 승인반려 되었습니다.\n반려사유를 확인하세요',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_REJECT_ADJ_PRICE_2: {
    colorInfo: ColorMap.red,
    buttonText: '상품 반려',
    bodyText: '단가조정 2차 승인반려 되었습니다.\n반려사유를 확인하세요',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_REJECT_NEW_REG_1: {
    colorInfo: ColorMap.red,
    buttonText: '상품 반려',
    bodyText: '신규등록 1차 승인반려 되었습니다.\n반려사유를 확인하세요',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_REJECT_NEW_REG_2: {
    colorInfo: ColorMap.red,
    buttonText: '상품 반려',
    bodyText: '신규등록 2차 승인반려 되었습니다.\n반려사유를 확인하세요',
    linkUrl: '/good/approval/history',
  },
  PRODUCT_REQUEST_MOD_INFO_1: {
    colorInfo: ColorMap.grey,
    buttonText: '상품 승인 요청',
    bodyText: '정보수정 1차 승인을 요청드립니다.',
    linkUrl: '/good/approval/management-md',
  },
  PRODUCT_REQUEST_MOD_INFO_2: {
    colorInfo: ColorMap.grey,
    buttonText: '상품 승인 요청',
    bodyText: '정보수정 2차 승인을 요청드립니다.',
    linkUrl: '/good/approval/management-rm',
  },
  PRODUCT_REQUEST_ADJ_PRICE_1: {
    colorInfo: ColorMap.grey,
    buttonText: '상품 승인 요청',
    bodyText: '단가조정 1차 승인을 요청드립니다.',
    linkUrl: '/good/approval/management-md',
  },
  PRODUCT_REQUEST_ADJ_PRICE_2: {
    colorInfo: ColorMap.grey,
    buttonText: '상품 승인 요청',
    bodyText: '단가조정 2차 승인을 요청드립니다.',
    linkUrl: '/good/approval/management-rm',
  },
  PRODUCT_REQUEST_NEW_REG_1: {
    colorInfo: ColorMap.grey,
    buttonText: '상품 승인 요청',
    bodyText: '신규등록 1차 승인을 요청드립니다.',
    linkUrl: '/good/approval/management-md',
  },
  PRODUCT_REQUEST_NEW_REG_2: {
    colorInfo: ColorMap.grey,
    buttonText: '상품 승인 요청',
    bodyText: '신규등록 2차 승인을 요청드립니다.',
    linkUrl: '/good/approval/management-rm',
  },

  PROMOTION_COMPLETE_REG_APPROVE: {
    colorInfo: ColorMap.blue,
    buttonText: '프로모션 승인 완료',
    bodyText: '프로모션 등록 승인완료 되었습니다.',
    linkUrl: '/promo/promotion-management',
  },
  PROMOTION_COMPLETE_MOD_APPROVE: {
    colorInfo: ColorMap.blue,
    buttonText: '프로모션 승인 완료',
    bodyText: '프로모션 수정 승인완료 되었습니다.',
    linkUrl: '/promo/promotion-management',
  },
  PROMOTION_REJECT_REG_APPROVE: {
    colorInfo: ColorMap.red,
    buttonText: '프로모션 반려',
    bodyText: '프로모션 등록 승인반려 되었습니다.\n반려사유를 확인하세요',
    linkUrl: '/promo/promotion-management',
  },
  PROMOTION_REJECT_MOD_APPROVE: {
    colorInfo: ColorMap.red,
    buttonText: '프로모션 반려',
    bodyText: '프로모션 수정 승인반려 되었습니다.\n반려사유를 확인하세요',
    linkUrl: '/promo/promotion-management',
  },
  PROMOTION_REQUEST_REG_APPROVE: {
    colorInfo: ColorMap.blue,
    buttonText: '프로모션 승인 요청',
    bodyText: '프로모션 신규 등록 승인을 요청드립니다.',
    linkUrl: '/promo/promotion-approval-management',
  },
  PROMOTION_REQUEST_MOD_APPROVE: {
    colorInfo: ColorMap.blue,
    buttonText: '프로모션 승인 요청',
    bodyText: '프로모션 신규 수정 승인을 요청드립니다.',
    linkUrl: '/promo/promotion-approval-management',
  },
};

export const useAlarmTemplate = () => {
  const getContents = (alarmType, alarmParameter) => {
    const parameters = JSON.parse(alarmParameter.replace(/&quot;/g, '"'));
    return {
      bodyTitle: `[${parameters?.type || ''}/${parameters?.name || ''}]`,
      ...ALARM_TYPE[`${alarmType}`],
    };
  };

  return {
    getContents,
  };
};
